/* unplugin-vue-components disabled */import { render } from "./AppLayout.vue?vue&type=template&id=3bd50e3e&scoped=true"
import script from "./AppLayout.vue?vue&type=script&lang=js"
export * from "./AppLayout.vue?vue&type=script&lang=js"

import "./AppLayout.vue?vue&type=style&index=0&id=3bd50e3e&scoped=true&lang=scss"
import "./AppLayout.vue?vue&type=style&index=1&id=3bd50e3e&scoped=global&lang=scss"

import exportComponent from "D:\\Develop\\Workspaces\\WeApp\\blockchain_ait_h5\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3bd50e3e"]])

export default __exports__